<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('bill.check_immediately') }}</div>
    <div slot="body">
      <dialog-selected-tips :count="params.data.length" :action="$t('bill.check_immediately')" :name="$t('bill.analysis_cost_alarm')" />
      <dialog-table v-if="params.columns && params.columns.length" :data="params.data" :columns="params.columns.slice(0, 3)" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t("dialog.ok") }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BillAnalysisAlarmCheckDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
    }
  },
  destroyed () {
    this.manager = null
  },
  created () {
    this.manager = new this.$Manager('bill_analysis_alarms', 'v1')
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        this.params.onManager('performAction', {
          id: this.params.data[0].id,
          steadyStatus: this.params.list?.steadyStatus,
          managerArgs: {
            action: 'check',
          },
        })
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
